// ** React Imports
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// ** Spinner Import
import Spinner from "src/@core/components/spinner";
// ** Hooks Import
import { useAuth } from "src/hooks/useAuth";
import { searchSuffixWithoutToken } from "src/@core/utils/urlQueryPreservation";

const stripTrailingSlash = (str) => {
  return str.endsWith("/") ? str.slice(0, -1) : str;
};

const PUBLIC_AUTH_PATHS = ["/login", "/register", "/forgot-password", "/reset-password", "/otp-login"];

const AuthGuard = ({ children }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = stripTrailingSlash(location.pathname);
    if (PUBLIC_AUTH_PATHS.includes(path)) return;
    if (auth.loading) return;
    if (auth.user !== null) return;

    const returnPath = location.pathname + searchSuffixWithoutToken(location.search);
    navigate(`/login?returnUrl=${encodeURIComponent(returnPath)}`);
  }, [auth.loading, auth.user, location.pathname, location.search, navigate]);

  if (auth.loading) {
    return <Spinner />;
  }

  return <> {children}</>;
};

export default AuthGuard;
